export function generatePrice(
  total_project_power,
) {
  let power = total_project_power;
  let price = 0;

  if (power >= 0 && power <= 10) {
    price = 490.0;
  } else if (power > 10 && power <= 20) {
    price = 690.0;
  } else if (power > 20 && power <= 40) {
    price = 890.0;
  } else if (power > 40 && power <= 60) {
    price = 1390.0;
  } else if (power > 60 && power <= 75) {
    price = 1990.0;
  } else if (power >= 76 && power <= 80) {
    price = 1990 + (power - 75) * 35;
  } else if (power >= 81 && power <= 90) {
    price = 2165 + (power - 80) * 35;
  } else if (power >= 91 && power <= 100) {
    price = 2515 + (power - 90) * 30;
  } else if (power >= 101 && power <= 110) {
    price = 2815 + (power - 100) * 25;
  } else if (power >= 111 && power <= 120) {
    price = 3065 + (power - 110) * 25;
  } else if (power >= 121 && power <= 130) {
    price = 3315 + (power - 120) * 25;
  } else if (power >= 131 && power <= 140) {
    price = 3565 + (power - 130) * 25;
  } else if (power >= 141 && power <= 150) {
    price = 3815 + (power - 140) * 25;
  } else if (power >= 151 && power <= 160) {
    price = 4065 + (power - 150) * 25;
  } else if (power >= 161 && power <= 170) {
    price = 4315 + (power - 160) * 25;
  } else if (power >= 171 && power <= 180) {
    price = 4565 + (power - 170) * 25;
  } else if (power >= 181 && power <= 190) {
    price = 4815 + (power - 180) * 25;
  } else if (power >= 191 && power <= 200) {
    price = 5065 + (power - 190) * 25;
  } else if (power >= 201 && power <= 210) {
    price = 5315 + (power - 200) * 25;
  } else if (power >= 211 && power <= 220) {
    price = 5565 + (power - 210) * 25;
  } else if (power >= 221 && power <= 230) {
    price = 5815 + (power - 220) * 25;
  } else if (power >= 231 && power <= 240) {
    price = 6065 + (power - 230) * 25;
  } else if (power >= 241 && power <= 250) {
    price = 6315 + (power - 240) * 25;
  } else if (power >= 251 && power <= 260) {
    price = 6565 + (power - 250) * 25;
  } else if (power >= 261 && power <= 270) {
    price = 6815 + (power - 260) * 25;
  } else if (power >= 271 && power <= 280) {
    price = 7065 + (power - 270) * 25;
  } else if (power >= 281 && power <= 290) {
    price = 7315 + (power - 280) * 25;
  } else if (power >= 291 && power <= 300) {
    price = 7565 + (power - 290) * 25;
  } else if (power >= 301 && power <= 310) {
    price = 7815 + (power - 300) * 25;
  } else if (power >= 311 && power <= 320) {
    price = 8065 + (power - 310) * 25;
  } else if (power >= 321 && power <= 330) {
    price = 8315 + (power - 320) * 25;
  } else if (power >= 331 && power <= 340) {
    price = 8565 + (power - 330) * 25;
  } else if (power >= 341 && power <= 350) {
    price = 8815 + (power - 340) * 25;
  } else if (power >= 351 && power <= 360) {
    price = 9065 + (power - 350) * 25;
  } else if (power >= 361 && power <= 370) {
    price = 9315 + (power - 360) * 25;
  } else if (power >= 371 && power <= 380) {
    price = 9565 + (power - 370) * 25;
  } else if (power >= 381 && power <= 390) {
    price = 9815 + (power - 380) * 25;
  } else if (power >= 391 && power <= 400) {
    price = 10065 + (power - 390) * 25;
  } else if (power >= 401 && power <= 410) {
    price = 10315 + (power - 400) * 25;
  } else if (power >= 411 && power <= 420) {
    price = 10565 + (power - 410) * 25;
  } else if (power >= 421 && power <= 430) {
    price = 10815 + (power - 420) * 25;
  } else if (power >= 431 && power <= 440) {
    price = 11065 + (power - 430) * 25;
  } else if (power >= 441 && power <= 450) {
    price = 11315 + (power - 440) * 25;
  } else if (power >= 451 && power <= 460) {
    price = 11565 + (power - 450) * 25;
  } else if (power >= 461 && power <= 470) {
    price = 11815 + (power - 460) * 25;
  } else if (power >= 471 && power <= 480) {
    price = 12065 + (power - 470) * 25;
  } else if (power >= 481 && power <= 490) {
    price = 12315 + (power - 480) * 25;
  } else if (power >= 491 && power <= 500) {
    price = 12565;
  } else if (power >= 501 && power <= 550) {
    price = 13815;
  } else if (power >= 551 && power <= 600) {
    price = 14815;
  } else if (power >= 601 && power <= 650) {
    price = 15815;
  } else if (power >= 651 && power <= 700) {
    price = 16815;
  } else if (power >= 701 && power <= 750) {
    price = 17815;
  } else if (power >= 751 && power <= 800) {
    price = 18815;
  } else if (power >= 801 && power <= 850) {
    price = 19815;
  } else if (power >= 851 && power <= 900) {
    price = 20815;
  } else if (power >= 901 && power <= 950) {
    price = 21815;
  } else if (power >= 951 && power <= 1000) {
    price = 22815;
  } else {
    return null;
  }

  return price;
}
